import React, { useContext, useState } from "react";
import "./UserProfile.css";
import { FaBox, FaHeart, FaHeadset } from "react-icons/fa";
import AddressStatCard from "../AddressStatCard/AddressStatCard";
import default_user from "../Assets/default_user.svg";
import { AuthContext } from "../../Context/AuthContext";
import OTPModal from "../OTPModal/OTPModal";
import { callMultipleApis } from "../../services/ApiServices";
import PageLoader from "../Assets/PageLoader/PageLoader";
import { useNavigate } from "react-router-dom";
import { ShopContext } from "../../Context/ShopContext";
import AddressModal from "../AddressModal/AddressModal";
import dropdownicon from "../Assets/nav_dropdown.png"
import AddressListModal from "../AddressListModel/AddressListModal";
import EditProfileModal from "../EditProfileModal/EditProfileModal";

const sendOTP = process.env.REACT_APP_SEND_OTP_URL;
const verifyOTP = process.env.REACT_APP_VERIFY_EMAIL_OTP_URL;
const saveAddress = process.env.REACT_APP_SAVE_ADDRESS_URL;
const deleteAddressURL = process.env.REACT_APP_DELETE_ADDRESS_URL;
const setAddressDefaultURL = process.env.REACT_APP_SET_ADDRESS_DEFAULT_URL;
const updateProfileURL = process.env.REACT_APP_UPDATE_PROFILE_URL;

const UserProfile = () => {
    const navigate = useNavigate();
    const { userDetails, login } = useContext(AuthContext);
    const { all_products } = useContext(ShopContext);
    const [otp, setOtp] = useState("");
    const [showOtpModal, setShowOtpModal] = useState(false);
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    const [openEditModel, setOpenEditModel] = useState(false);
    const [open, setOpen] = useState(false);
    const [openAddressList, setOpenAddressList] = useState(false);


    let wishlistCount = all_products.filter(
        (item) => Number(item.is_wishlist) === 1
    ).length;

    const primaryAddress = userDetails.customer_address.find(
        addr => Number(addr.is_default) === 1
    ) || '';



    const sendOTPToEmailId = async () => {

        try {
            setLoading(true);
            const data = {
                fullName: userDetails.name,
                email: userDetails.emailid,
                otptype: 'PROFILE_EMAIL_VERIFY'
            };

            const [resOTP] = await callMultipleApis([
                {
                    url: sendOTP,
                    method: "POST",
                    data: data,
                    params: {},
                    headers: {},
                }
            ]);

            if (resOTP.status === true) {
                alert(resOTP.message);
                setShowOtpModal(true);
            } else {
                alert(resOTP.message);
            }

        } catch (error) {
            alert("Server error. Try again.");
        } finally {
            setLoading(false);
        }

    }

    const handleResendOtp = async () => {
        setOtp("");
        setShowOtpModal(false);
        sendOTPToEmailId();
    }

    const verifyOtp = async () => {
        try {
            setLoading(true);
            const data = {
                email: userDetails.emailid,
                emailotp: otp,
                otptype: 'PROFILE_EMAIL_VERIFY'
            };

            const [resValidateOTP] = await callMultipleApis([
                {
                    url: verifyOTP,
                    method: "POST",
                    data: data,
                    params: {},
                    headers: {},
                }
            ]);

            if (resValidateOTP.status === true) {
                alert(resValidateOTP.message);
                setOtp("");
                login(resValidateOTP.result)
                setShowOtpModal(false);
            } else {
                //alert(resValidateOTP.message);
                setOtp("");
                setError(resValidateOTP.message)
            }
        } catch (error) {

        } finally {
            setLoading(false);
        }
    }

    const handleWishList = () => {
        navigate("/userwishlist");
    }

    const handleSupport = () => {
        navigate("/support");
    }

    const handleAddAddress = async (data) => {
        try {
            setLoading(true);
            data.email = userDetails.emailid;

            const [resSaveAddress] = await callMultipleApis([
                {
                    url: saveAddress,
                    method: "POST",
                    data: data,
                    params: {},
                    headers: {},
                }
            ]);

            if (resSaveAddress.status === true) {
                alert(resSaveAddress.message);
                login(resSaveAddress.result)
                setOpen(false);
            } else {
                alert(resSaveAddress.message);
            }
        } catch (error) {

        } finally {
            setLoading(false);
        }

    }

    const updateUserDetails = async (data, url) => {
        try {
            setLoading(true);
            data.email = userDetails.emailid;

            const [res] = await callMultipleApis([
                {
                    url: url,
                    method: "POST",
                    data: data,
                    params: {},
                    headers: {},
                }
            ]);

            if (res.status === true) {
                alert(res.message);
                login(res.result)
                setOpen(false);
                setOpenEditModel(false);
            } else {
                alert(res.message);
            }
        } catch (error) {

        } finally {
            setLoading(false);
        }

    }


    return (
        <div className="profile-page">
            <div className="profile-card">
                {/* Profile Header */}
                <div className="profile-header">
                    <img
                        src={default_user}
                        alt="User"
                        className="profile-avatar"
                    />
                    <div className="profile-info">
                        <h2>{userDetails.name}</h2>
                        <p className="email-row">
                            {userDetails.emailid}

                            {userDetails.is_email_verified ? (
                                <span className="verified-badge">Verified</span>
                            ) : (
                                <span className="unverified-badge">Not Verified</span>
                            )}

                            {!userDetails.is_email_verified && (
                                <button
                                    className="verify-email-btn"
                                    onClick={() => sendOTPToEmailId()}
                                >
                                    Verify Email
                                </button>
                            )}
                        </p>
                        <button className="edit-btn"
                            onClick={() => setOpenEditModel(true)}>Edit Profile</button>
                    </div>
                </div>

                {/* Stats */}
                <div className="profile-stats">
                    <div className="stat-card" onClick={() => {alert("Coming Soon...")}}>
                        <FaBox className="stat-icon" />
                        <div>
                            <h3>{userDetails.orderscount}</h3>
                            <p>Orders</p>
                        </div>
                    </div>

                    <div className="stat-card" onClick={handleWishList}>
                        <FaHeart className="stat-icon wishlist" />
                        <div>
                            <h3>{wishlistCount}</h3>
                            <p>Wishlist</p>
                        </div>
                    </div>

                    <AddressStatCard
                        totalAddresses={userDetails.addresscount}
                        maxAddresses={5}
                        primaryLabel={userDetails.primary_address}
                        setOpen={setOpen}
                    // onClick={(e) => {e.stopPropagation(); setOpen(true);} }
                    />

                    <div className="stat-card" onClick={handleSupport}>
                        <FaHeadset className="stat-icon support" />
                        <div>
                            <h3>Support</h3>
                            <p>Help & Tickets</p>
                        </div>
                    </div>
                </div>


                {/* Details */}
                <div className="profile-details">
                    <h3>Account Details</h3>

                    <div className="detail-row">
                        <h4>Phone</h4>
                        <span>+91 {userDetails.phoneno}</span>
                    </div>

                    <div className="detail-row">
                        <h4>Date Of Birth</h4>
                        <span>{userDetails.dob}</span>
                    </div>

                    <div className="detail-row">
                        <h4>Address</h4>
                        <div className="address-line">
                            <div className="address-text">
                                {primaryAddress.address_line1}<br />
                                {primaryAddress.address_line2} {primaryAddress.city}<br />
                                {primaryAddress.landmark}<br />
                                {primaryAddress.state} {primaryAddress.pincode}
                            </div>

                            <img
                                src={dropdownicon}
                                alt="View all addresses"
                                className="address-icon"
                                onClick={() => { setOpenAddressList(true) }}
                            />
                        </div>
                    </div>

                    <div className="detail-row">
                        <h4>Member Since</h4>
                        <span>{userDetails.member_since}</span>
                    </div>
                </div>
            </div>

            {loading && (
                <PageLoader text="" />
            )}

            <OTPModal
                open={showOtpModal}
                email={userDetails.email}
                otp={otp}
                setOtp={setOtp}
                error={error}
                loading={loading}
                onClose={() => setShowOtpModal(false)}
                onVerify={verifyOtp}
                onResend={handleResendOtp}
                verifyText="Verify"
            />


            <AddressModal
                isOpen={open}
                onClose={() => setOpen(false)}
                onSave={(data) => { handleAddAddress(data); }}
                initialData={userDetails}
            />

            <AddressListModal
                isOpen={openAddressList}
                onClose={() => setOpenAddressList(false)}
                addresses={userDetails.customer_address}
                onAddAddress={() => { setOpenAddressList(false); setOpen(true); }}
                onDeleteAddress={(id) => {
                    const data = {
                        email: userDetails.emailid,
                        addressid: id,
                    };
                    updateUserDetails(data, deleteAddressURL);
                }}
                onMakePrimary={(id) => {
                    const data = {
                        email: userDetails.emailid,
                        addressid: id,
                    };
                    updateUserDetails(data, setAddressDefaultURL);
                }}
            />

            <EditProfileModal
                isOpen={openEditModel}
                onClose={() => setOpenEditModel(false)}
                user={userDetails}
                onSave={(data) => updateUserDetails(data, updateProfileURL)}
            />;

        </div>
    );
};

export default UserProfile;
